module.exports = __webpack_public_path__ + "img/A2M6.935f9877.jpg";